import { Controller } from "@hotwired/stimulus"

// Botón "App Mobile" en la tarjeta del paciente: genera el código de
// activación de la App (PatientAccessToken a 30 días) y permite copiarlo
// o enviarlo por WhatsApp (template `acceso_app`, con fallback a texto libre).
export default class extends Controller {
  static targets = ["modal", "code", "expiry", "error", "success", "sendButton"]
  static values = { patientId: Number }

  open(event) {
    event.preventDefault()
    this.message = null
    this.resetAlerts()
    this.codeTarget.textContent = "Generando…"
    this.expiryTarget.textContent = "…"
    $(this.modalTarget).modal("show")

    this.request("create_for_app")
      .then((data) => {
        this.message = data.message
        this.codeTarget.textContent = data.code
        this.expiryTarget.textContent = data.expires_at
      })
      .catch((err) => {
        this.codeTarget.textContent = "—"
        this.showError(err.message)
      })
  }

  copyMessage(event) {
    event.preventDefault()
    if (!this.message) return

    this.resetAlerts()
    const onSuccess = () => this.showSuccess("Mensaje copiado. Pegalo en el chat del paciente.")
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(this.message).then(onSuccess).catch(() => this.fallbackCopy(onSuccess))
    } else {
      this.fallbackCopy(onSuccess)
    }
  }

  sendWhatsapp(event) {
    event.preventDefault()
    if (!this.message) return
    if (!confirm("¿Enviar el código de acceso a la App por WhatsApp a este paciente?")) return

    this.resetAlerts()
    this.sendButtonTarget.disabled = true

    this.request("send_app_access")
      .then((data) => this.showSuccess(data.message || "Código enviado por WhatsApp"))
      .catch((err) => this.showError(err.message))
      .finally(() => { this.sendButtonTarget.disabled = false })
  }

  // --- helpers ---

  request(action) {
    return fetch(`/patients/${this.patientIdValue}/patient_access_tokens/${action}.json`, {
      method: "POST",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.getAttribute("content"),
        "Accept": "application/json",
        "Content-Type": "application/json",
      },
      credentials: "same-origin",
    }).then((response) =>
      response.json().then((data) => {
        if (!response.ok || !data.success) {
          throw new Error((data.errors || []).join(", ") || `HTTP ${response.status}`)
        }
        return data
      })
    )
  }

  fallbackCopy(onSuccess) {
    const textarea = document.createElement("textarea")
    textarea.value = this.message
    textarea.style.position = "fixed"
    textarea.style.opacity = "0"
    document.body.appendChild(textarea)
    textarea.select()
    try {
      document.execCommand("copy")
      onSuccess()
    } catch (e) {
      this.showError("No se pudo copiar automáticamente. Copiá el código a mano.")
    } finally {
      document.body.removeChild(textarea)
    }
  }

  resetAlerts() {
    this.errorTarget.classList.add("d-none")
    this.successTarget.classList.add("d-none")
  }

  showError(message) {
    this.errorTarget.textContent = message
    this.errorTarget.classList.remove("d-none")
  }

  showSuccess(message) {
    this.successTarget.textContent = message
    this.successTarget.classList.remove("d-none")
  }
}
